import { createSlice } from '@reduxjs/toolkit';

export interface IConfigState {
  isJivoBotEnabled: boolean;
}

const initialState: IConfigState = {
  isJivoBotEnabled: false,
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setIsJivoBotEnabled: (state, action) => {
      state.isJivoBotEnabled = action.payload as boolean;
    },
  },
});

export const {
  reducer: configReducer,
  actions: { setIsJivoBotEnabled },
} = configSlice;
